import styled from 'styled-components'
import { FlexContainer } from 'heliocor-ui'
import 'styled-components/macro'

const WrapperVideo = styled(FlexContainer)`
    position: relative;
    width: 320px;
    height: 240px;
`

const VideoReplay = styled.video`
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
`

const ButtonRec = styled.button`
  background: ${({theme, type}) => type === 'REC' ? theme.colors.main : theme.colors.grey300};
  border-radius: ${({type}) => type === 'REC' ? '50%' : '20%'};
  width: 2rem;
  height: 2rem;
  outline: none;
  border: none;
  cursor: pointer;
  :hover {
    filter: saturate(80%);
  }
`
const ButtonRecBorder = styled.div`
    border: 8px solid rgba(255, 255, 255, 0.4);
    height: 3rem;
    width: 3rem;
    border-radius: ${({type}) => type === 'REC' ? '50%' : '35%'};
`

const CountdownContainer = styled(FlexContainer)`
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 100;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: auto;
    padding: .2rem;
    aspect-ratio: 1;
    border-top-right-radius: 20%;
    background-color: ${({theme}) => theme.colors.main};
`

const CountdownSection = styled.span`
  line-height: 1em;
  display: inline-flex;
`

const CountdownNumber = styled.span`
  height: 1em;
  width: 2em;
  display: inline-block;
  overflow-y: hidden;
  color: white;

  &::after {
    position: relative;
    white-space: pre;
    content: '${({content}) => content}';
    top: calc(${({seconds}) => seconds} * -1em);
    text-align: center;
    transition: all 1s cubic-bezier(1,0,0,1);
  }
`

export {
    ButtonRec,
    ButtonRecBorder,
    CountdownContainer,
    CountdownSection,
    CountdownNumber,
    VideoReplay,
    WrapperVideo
}